module.exports = __webpack_public_path__ + "static/media/BAP2-extra.00b9fccf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP2-extra.png
 ** module id = 679
 ** module chunks = 0
 **/